'use client';

import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { GameCard } from '@/components/shared/m-game-card';
import { useGames } from '@/features/games/hooks/useGames';
import { useHotGames } from '@/features/games/hooks/useHotGames';

interface HotGamesProps {
  categoryId?: string;
}

export const HotGames = ({ categoryId }: HotGamesProps) => {
  const { data: globalHotGames = [], isLoading: globalLoading } =
    useHotGames(3);

  const { data: categoryGamesPage, isLoading: categoryLoading } = useGames({
    categoryId,
    hot: true,
    limit: 3,
  });

  const isLoading = categoryId ? categoryLoading : globalLoading;
  const hotGames = categoryId
    ? (categoryGamesPage?.games ?? [])
    : globalHotGames;

  if (isLoading && hotGames.length === 0) {
    return (
      <div className="py-2">
        <h4 className="font-bold text-sm text-[#FFA035] px-4 pb-2">
          Hot Games 🔥🔥🔥
        </h4>
        <div className="p-2 grid grid-cols-3 gap-2 bg-[#801C80]/40 rounded-lg mx-2 animate-pulse">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: skeleton loading cards
              key={`hot-skeleton-${i}`}
              className="h-[120px] rounded-lg bg-white/5"
            />
          ))}
        </div>
      </div>
    );
  }

  if (hotGames.length === 0) {
    return null;
  }

  return (
    <div className="py-2">
      <div className="flex justify-between items-center px-4 pb-2">
        <h4 className="font-bold text-sm text-[#FFA035]">Hot Games 🔥🔥🔥</h4>
        <Link
          href="/pages/m-more-games?type=hot"
          className="text-[10px] text-white flex items-center gap-1 cursor-pointer hover:opacity-80 active:opacity-70"
        >
          more games <ChevronRight className="size-3" />
        </Link>
      </div>
      <div className="p-2 grid grid-cols-3 gap-2 bg-[#801C80]/40 rounded-lg mx-2">
        {hotGames.map(game => (
          <GameCard
            key={game.id}
            gameId={game.id}
            imageUrl={game.image ?? undefined}
            title={game.name}
            liked={game.isFavorite}
          />
        ))}
      </div>
    </div>
  );
};
